var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.327555 3.98275C0.117333 4.20475 0 4.49634 0 4.79994V14.1394C0 16.2082 1.08533 18.1306 2.87222 19.2274C5.76278 21.0009 10.3522 23.8173 10.3522 23.8173C10.7482 24.0609 11.2518 24.0609 11.6478 23.8173C11.6478 23.8173 16.2372 21.0009 19.1278 19.2274C20.9147 18.1306 22 16.2082 22 14.1394V4.79994C22 4.49634 21.8827 4.20475 21.6724 3.98275C19.6729 1.87198 15.6518 0 11 0C6.34822 0 2.32711 1.87198 0.327555 3.98275ZM19.5556 5.29553C17.8053 3.69115 14.619 2.39997 11 2.39997C7.381 2.39997 4.19467 3.69115 2.44444 5.29553V14.1394C2.44444 15.3802 3.09589 16.5346 4.16778 17.1922L11 21.3849L17.8322 17.1922C18.9041 16.5346 19.5556 15.3802 19.5556 14.1394V5.29553ZM9.77778 12.703L15.0248 7.55151C15.5014 7.08351 16.2763 7.08351 16.753 7.55151C17.2297 8.0195 17.2297 8.78029 16.753 9.24828L10.6419 15.2482C10.1652 15.7174 9.39033 15.7174 8.91367 15.2482L5.247 11.6483C4.77033 11.1803 4.77033 10.4195 5.247 9.95148C5.72367 9.48348 6.49856 9.48348 6.97522 9.95148L9.77778 12.703Z",
    fill: "#D9808A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.198d070ebf60b806b6b52dc161c3c2bd.svg";
export { ForwardRef as ReactComponent };